export default __webpack_public_path__ + "static/g3three-fafff4587e762a12733e0aae9207af6f.jpg";